import { Container } from 'react-bootstrap'

import NavbarPages from '../NavbarPages'
import HeaderPages from '../HeaderPages'
import KiveUso from '../../../Resourses/products/rami-uso-hilo-pasticos-generales-celeste.svg'

const imgHeader = "./images/productos/header-internas-rami-hilos-plasticos.jpg";
const imgThumbIzq = "./images/productos/productos_thumbs--hilo-plastico-rami.jpg";
const altText = "CINTA DE EMPAQUE";

const tipoColor = 'productos__detail--tipoHiloPlasticosCeleste'

const detailLine1 = "HILOS";
// const detailLine2 = "ADHESIVA";
const detailLine3 = "PLÁSTICOS";

const imgTable ="./images/productos/rami/cuadro-rami-hilo-plastico.jpg";


const textoDetail1 = 'Hilos y Cintas de polipropileno, son muy resistentes, ideal para sujetar y/o atar todo tipo de embalajes como : cajas, bolsas, bultos, fardos, etc.'
const textoDetail2 = 'Lo que permiten transportar tus productos de forma segura.'
const textoDetail3 = 'Se fabrican con material recuperado en colores oscuros (del SCRAP de desechos plásticos) y sino con 100% de materia prima Virgen en color cristal que le otorga una mayor resistencia y rendimiento.'

const imgThumb1 = './images/productos/rami-hilo-plastico/rami-hilo-plastico-1.jpg';
const imgThumb1Alt = 'Hilo plastico 7002.';

const imgThumb2 = './images/productos/rami-hilo-plastico/rami-hilo-plastico-2.jpg';
const imgThumb2Alt = 'Hilo plastico 7003.';

const imgThumb3 = './images/productos/rami-hilo-plastico/rami-hilo-plastico-3.jpg';
const imgThumb3Alt = 'Hilo plastico 7005.';

const HilosPlasticosRami = () => {
  return (
    <Container className='mb-0'>
        <NavbarPages className="p-0" />
        <div className='row'>
          <div className='col-12 mb-4'>
            <HeaderPages img={imgHeader} alt={"Productos Kive Cintas"} />
          </div>
          <div className='col-12 col-sm-6 col-md-5 productos__imgContainer'>
            <img 
              src={imgThumbIzq} 
              alt={altText} 
              className='d-block w-100 productos__imgContainer--img' 
              loading='lazy'/>
          </div>
          <div className='col-12 col-sm-12 col-md-7 productos__vert--int mb-4 mt-1'>
            <div className='row productos__detail'>
              <div className='col-12'>
                <p className={`productos__detail--caracteristica productos__detail--tipo ${tipoColor}`}>{detailLine1}
                 {/* <span className={`productos__detail--caracteristica ${tipoColor}`}> {detailLine2}</span> */}
                </p>
                <p className={`productos__detail--caracteristica ${tipoColor}`}>{detailLine3}</p>
                <img src={KiveUso} className='d-block productos__detail--svg' alt='' loading="lazy" />
              </div>
              <div className='col-12 productos__detail'>
                <img  src={imgTable} 
                      className='d-block w-100' 
                      alt={altText}
                      loading="lazy" />
              </div>
            </div>
          </div>
          <div className='col-12 col-sm-12 col-md-12 productos__vert mb-4 mt-1'>
            <p className='site_text productos__text--int mb-0'> 
              {textoDetail1}<br/>
              {textoDetail2}<br/>
              {textoDetail3}
            </p>
          </div>
        </div>
        <div className='row'>
        
            <div className='col-12 col-sm-12 col-md-6 col-lg-4 mb-4' >
              <img src={imgThumb1} className='d-block w-100 p-0 m-0 ' alt={ imgThumb1Alt} loading="lazy" />
            </div>
            <div className='col-12 col-sm-12 col-md-6 col-lg-4 mb-4' >
              <img src={imgThumb2} className='d-block w-100 p-0 m-0 ' alt={ imgThumb2Alt} loading="lazy" />
            </div>
            <div className='col-12 col-sm-12 col-md-6 col-lg-4 mb-4' >
              <img src={imgThumb3} className='d-block w-100 p-0 m-0 ' alt={ imgThumb3Alt} loading="lazy" />
            </div>
           
        </div>       
      </Container>
    
  )
}

export default HilosPlasticosRami